var _path, _path2, _path3, _path4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPermisionGroups(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9727 12.9728C12.9727 9.40525 15.8916 6.48633 19.4591 6.48633C23.0267 6.48633 25.9456 9.40525 25.9456 12.9728C25.9456 16.5404 23.0267 19.4593 19.4591 19.4593C15.8916 19.4593 12.9727 16.5404 12.9727 12.9728Z",
    fill: "#3D5BA9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7031 30.8107C22.7031 26.3513 26.3518 22.7026 30.8112 22.7026C35.2707 22.7026 38.9193 26.3513 38.9193 30.8107C38.9193 35.2702 35.2707 38.9189 30.8112 38.9189C26.3518 38.9189 22.7031 35.2702 22.7031 30.8107Z",
    fill: "#3D5BA9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6566 22.6431C22.5163 24.1581 21.1123 26.6528 21.1123 29.4594C21.1123 30.0307 21.1705 30.589 21.2812 31.1288H7.75781V27.7901C8.87069 23.8951 12.3206 22.6431 19.2575 22.6431H24.6566Z",
    fill: "#3D5BA9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.58203 20C2.58203 10.423 10.424 2.58105 20.001 2.58105C29.5779 2.58105 37.4199 10.423 37.4199 20C37.4199 21.2587 37.2844 22.4874 37.0274 23.6722C37.4716 24.0882 37.876 24.5462 38.234 25.0397C38.6809 23.4337 38.9199 21.7434 38.9199 20C38.9199 9.59457 30.4064 1.08105 20.001 1.08105C9.59555 1.08105 1.08203 9.59457 1.08203 20C1.08203 30.4054 9.59555 38.9189 20.001 38.9189C21.7444 38.9189 23.4347 38.6799 25.0407 38.2331C24.5471 37.875 24.0891 37.4706 23.6732 37.0264C22.4883 37.2834 21.2596 37.4189 20.001 37.4189C10.424 37.4189 2.58203 29.577 2.58203 20Z",
    fill: "#3D5BA9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_646_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.419 30.8715L31.6015 30.5066L35.6758 35.0674L35.6758 33.8512L31.9663 29.5944C32.0271 29.412 32.0271 29.2296 32.0271 28.9863C32.0271 27.2836 30.6893 25.9458 28.9866 25.9458C27.2839 25.9458 25.9461 27.3444 25.9461 28.9863C25.9461 30.6282 27.2839 32.0269 28.9866 32.0269C29.3515 32.0269 29.7163 31.9661 30.0204 31.8444L30.8109 32.635L32.0271 32.635L32.0271 33.8512L33.2433 33.8512L33.2433 35.0674L33.8515 35.6755L35.6758 35.6755L31.419 30.8715ZM27.6488 28.3782C27.6488 27.9526 28.0136 27.6485 28.3785 27.6485C28.7433 27.6485 29.1082 28.0134 29.1082 28.3782C29.1082 28.7431 28.7433 29.108 28.3785 29.108C28.0136 29.108 27.6488 28.8039 27.6488 28.3782Z",
    fill: "#FFD435"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_646_4146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.72973,
    height: 9.72973,
    fill: "white",
    transform: "translate(35.6758 25.9458) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermisionGroups);
export default __webpack_public_path__ + "static/media/PermisionGroups.e0e00d962e5c974d98266a07d68e2ef2.svg";
export { ForwardRef as ReactComponent };